import * as React from 'react';
import { createPortal } from 'react-dom';

import { createStore } from 'zustand';

import { DrawerContext } from '@notino/react-styleguide';
import { WishlistList } from '@notino/shared/definitions/types';

import './index.css';
import { Content } from './Content';
import {
  ListMenuContextProvider,
  ListMenuDrawerStoreValue,
  useCloseListMenuDrawer,
} from './context';
import { Header } from './Header';

type Props = {
  list: WishlistList & { isShared?: boolean };
  onClose: () => void;
};

export const ListMenuDrawer = ({ list, onClose }: Props) => {
  const [store] = React.useState(
    createStore<ListMenuDrawerStoreValue>(() => ({
      list,
      currentAction: 'rootMenu',
    }))
  );

  return createPortal(
    <ListMenuContextProvider
      value={{
        store,
        onClose: () => setTimeout(onClose, 400),
      }}
    >
      <DrawerContext.Provider>
        <Drawer />
      </DrawerContext.Provider>
    </ListMenuContextProvider>,
    document.getElementById('nushop-portal-root')
  );
};

const Drawer = () => {
  const { openDrawer } = DrawerContext.useDrawerContext();
  const onClose = useCloseListMenuDrawer();

  React.useEffect(() => {
    openDrawer(<Content />, {
      title: <Header />,
      hideScrollbar: true,
      initialPosition: 'dynamic',
      showFade: false,
      headerCustomStyles: 'list-menu-drawer-header',
      onClose,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
